module.exports = __webpack_public_path__ + "ceed18e4e2b5c20ea9a023c4c0f6b3c5.svg";